import React from 'react';
import HeaderTags from '../../common/headerTags/HeaderTags';
import AplicativosComponent from '../../components/aplicativosPage/component/AplicativosPageComponent';


const headerTags =
    {
        title: 'Todos os Aplicativos para ouvir a sua rádio preferida', // | Antena 1 is automatically added by the Headers Tag
        meta:
            {
                description: 'Baixe o aplicativo nas mais diversas plataformas e tenha a Antena 1 em qualquer lugar e horário. O melhor da música internacional sempre com você!',
                keywords: 'download, baixar, app, música, smartphones, Tablets, Smart TVs, Alexa, Apple TV, Samsung TV, LG, Firestick, Smart Watches, Relógios, Google Speaker',
                'og:title': 'Todos os Aplicativos para ouvir a sua rádio preferida',
                'og:description': 'Baixe o aplicativo nas mais diversas plataformas e tenha a Antena 1 em qualquer lugar e horário. O melhor da música internacional sempre com você!',
                'og:image': 'https://a1media.antena1.com.br/image/share/aplicativos.png',
            },
    };


const Aplicativos = () => (
    <div className="pageWrapper">
        <HeaderTags title={headerTags.title} meta={headerTags.meta} />
        <AplicativosComponent />
    </div>
);

export default Aplicativos;
